
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tag/[[...keywords]]",
      function () {
        return require("private-next-pages/tag/[[...keywords]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tag/[[...keywords]]"])
      });
    }
  